import blockColdFromWindows from './block-cold-from-windows/images/block-cold-from-windows.png?w=250';
import churchStormWindows from './church-storm-windows/images/church-storm-windows.png?w=250';
import energyEfficiencyOldHomes from './energy-efficiency-old-homes/images/energy-efficiency-old-homes.png?w=250';
import insulateDoublePaneWindows from './insulate-double-pane-windows/images/insulate-double-pane-windows.jpg?w=250';
import officeSoundproofing from './office-soundproofing/images/office-soundproofing.png?w=250';
import sleepPanelsTotalDarkness from './sleep-panels-total-darkness/images/thumb.png?w=250';
import soundproofingWindowsNyc from './soundproofing-windows-nyc/images/soundproofing-windows-nyc.png?w=250';
import stopWindowCondensation from './stop-window-condensation/images/stop-window-condensation.png?w=250';
import streetNoiseReduction from './street-noise-reduction/images/noisy-traffic-jam.jpeg?w=250';
import thisOldHouseCharleston from './this-old-house-charleston/images/this-old-house-charleston.png?w=250';
import windowPrivacyIdeas from './window-privacy-ideas/images/window-privacy-ideas.png?w=250';
import windowReplacementAlternative from './window-replacement-alternative/images/window-replacement-alternative.png?w=250';

export const featured = [
	{
		group: 'comfort',
		title: 'COMFORT & ENERGY SAVINGS',
		items: [
			{
				title: 'The U.S. DOE Studies Historic Home Energy Efficiency',
				href: '/resources/case-studies/energy-efficiency-old-homes',
				subtitle:
					'The U.S. Department of Energy found Indow inserts lead to a 20 percent reduction in heating and cooling costs in a Seattle home.',
				image: energyEfficiencyOldHomes,
				featured: true,
			},
			{
				title: 'Insulating Double-Pane Windows When They Fail',
				href: '/resources/case-studies/insulate-double-pane-windows',
				subtitle:
					'A homeowner reduced energy bills and drafts by adding Indow inserts to their inefficient double-pane windows.',
				image: insulateDoublePaneWindows,
				featured: true,
			},
			{
				title: 'Losing Church Heating Through the Windows',
				href: '/resources/case-studies/church-storm-windows',
				subtitle:
					'A historic church in Portland installed Indow inserts to reduce noise and drafts without altering its original stained glass windows.',
				image: churchStormWindows,
				featured: true,
			},
			{
				title: 'The #1 Window Replacement Alternative',
				href: '/resources/case-studies/window-replacement-alternative',
				subtitle:
					'A couple in a historic home used Indow inserts as a cost-effective, non-invasive alternative to window replacement, preserving aesthetics while improving comfort.',
				image: windowReplacementAlternative,
				featured: true,
			},
		],
	},
];
export const caseStudies = [
	...featured,
	{
		group: 'noise',
		title: 'NOISE REDUCTION',
		items: [
			{
				title: 'Street Noise Reduction in the City',
				href: '/resources/case-studies/street-noise-reduction',
				subtitle:
					'Constant traffic noise made it hard for this family to sleep and almost forced them to move before they found Indow inserts.',
				image: streetNoiseReduction,
			},
			{
				title: 'This Old House Charleston + Indow',
				subtitle:
					'Understanding the value of original windows, This Old House uses inserts to block drafts and noise in an 1847 home in Charleston’s historic district.',
				href: '/resources/case-studies/this-old-house-charleston',
				image: thisOldHouseCharleston,
			},
			{
				title: 'Reduce Train Noise with Office Soundproofing',
				href: '/resources/case-studies/office-soundproofing',
				subtitle:
					'This building manager installed Indow inserts to soundproof his tenants’ offices, and was blown away by the impressive reduction in sound.',
				image: officeSoundproofing,
			},
			{
				title: 'Soundproofing Windows In NYC',
				href: '/resources/case-studies/soundproofing-windows-nyc',
				subtitle:
					'A Brooklyn couple soundproofed their apartment using Indow inserts to block city noise while preserving natural light and views.',
				image: soundproofingWindowsNyc,
			},
		],
	},
	{
		group: 'more',
		title: '...AND MORE!',
		items: [
			{
				title: 'Blocking Cold Air & UV Light In A Historic Home',
				href: '/resources/case-studies/block-cold-from-windows',
				subtitle:
					'Owners of the iconic Case Study House #26 in California used inserts to protect paintings from damaging UV rays.',
				image: blockColdFromWindows,
			},
			{
				title: 'Window Privacy For Urban Living',
				href: '/resources/case-studies/window-privacy-ideas',
				subtitle:
					'Privacy Grade inserts helped one urban dweller shield his home from view of hotel guests next door while reducing grime filtering through his windows.',
				image: windowPrivacyIdeas,
			},
			{
				title: 'Stop Window Condensation',
				href: '/resources/case-studies/stop-window-condensation',
				subtitle:
					'A Portland homeowner eliminated window condensation and improved comfort by installing Indow inserts during a home renovation.',
				image: stopWindowCondensation,
			},
			{
				title: 'Total Darkness for Restful Sleep',
				href: '/resources/case-studies/sleep-panels-total-darkness',
				subtitle:
					'Struggle with unwanted light disrupting your sleep? Discover how Indow Sleep Panels create complete darkness for deeper, more restful sleep.',
				image: sleepPanelsTotalDarkness,
			},
		],
	},
];
